import React, { useContext, useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import styles from '../css/share/share-button.module.css';
import shareIcon from '../../images/shareIcon.svg';
import shareIconWhite from '../../images/shareIconWhite.svg';
import { createShareCode } from '../../adapters/share-adapter';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { ShareLinkContext } from './ShareLinkContext';

function ShareButton({ entryId, shareType, buttonType, feeling, color }) {
    const auth = getAuth();
    const [user] = useAuthState(auth);
    const userId = user?.uid;

    const location = useLocation();
    const isInShareMode = location.pathname.includes('shared');

    const [showLabel, setShowLabel] = useState(true);
    const { setShowShareModal, setShareLink, setShareCode } = useContext(ShareLinkContext);

    let buttonText = 'Share';
    let buttonStyle = {};
    if (shareType?.includes('story')) {
        buttonText = 'Share your week';
        buttonStyle = { padding: "0.5rem 0.75rem" };
    }

    useEffect(() => {
        if (shareType === 'flow') { // aka button is on a flow
            if (location.pathname.includes('reflection') || window.innerWidth < 600) {
                setShowLabel(false);
            }
        }
    }, [location])

    const onClick = async () => {
        const result = await createShareCode(userId, entryId, shareType);
        if (!result?.shareCode) {
            return;
        }
        setShareCode(result.shareCode);

        const name = encodeURIComponent(result.sharerName);
        let link = process.env.REACT_APP_LANDING_PAGE_URL || 'https://normili.com';
        if (shareType === 'flow') {
            const urlFeeling = encodeURIComponent(feeling?.toLowerCase());
            link = `${link}/shared?${shareType}=${result.shareCode}&u=${name}&f=${urlFeeling}&c=${color}`
        }
        else if (shareType === 'story') {
            link = `${link}/shared?story=${result.shareCode}&u=${name}`;
        }
        setShareLink(link);
        setShowShareModal(true);
    }

    return (
        isInShareMode ? <></> :
            buttonType === 'storyShareIcon'
                ? <button className={styles.shareIconBtn} onClick={onClick}>
                    <img className={styles.icon} src={shareIconWhite} alt="share icon" height={22} />
                </button>

                : <div className={styles.shareDiv}>
                    <button onClick={onClick} className={styles.shareButton} style={buttonStyle}>
                        <img className={styles.icon} src={shareIcon} alt="share icon" />
                        {showLabel && <span className={styles.label}>{buttonText}</span>}
                    </button>
                </div>
    )
}

export default ShareButton;